<template>
    <div :style=" me ? alignRight : alignLeft " class="chat-groupmessage--wrapper">
        <avartar class="chat-groupmessage--avatar" :name="name" v-if="!me"/>
        <div class="chat-groupmessage--content">
            <div style="display: inline-block; align-self: flex-end" :style=" me ? alignRight : alignLeft ">
                <span v-if="!me" style="font-size: 12px">{{ name }} - </span>
                <span style="font-size: 12px; text-align: right">{{ time }}</span>
            </div>
            <slot></slot>
            <message
                    v-for="(msg, index) in mgsList"
                    :message="msg.content"
                    :key="index"
                    :me="me"
                    :first="msg.first"
                    :end="msg.end"
                    :isShowRead="lastReadId && lastReadId === msg.id"
                    :wait="msg.wait"
            >
            </message>
        </div>
    </div>
</template>

<script>
import Message from './Message'
import Avartar from './Avartar'

export default {
  name: 'GroupMessage',
  components: {
    Message,
    Avartar
  },
  props: {
    mgsList: Array,
    name: String,
    me: Boolean,
    time: String,
    lastReadId: String
  },
  data () {
    return {
      alignLeft: {
        'align-self': 'flex-start',
      },
      alignRight: {
        'align-self': 'flex-end',
      }
    }
  }
}
</script>

<style lang="scss">
.chat-groupmessage--wrapper {
    display: flex;
    max-width: 75%;
    margin-top: 4px;
    margin-left: 20px;
    margin-right: 20px;
    flex: 0 0 auto;
    .chat-groupmessage--avatar {
        flex: 0 0 auto;
    }
    .chat-groupmessage--content {
        display: flex;
        flex-direction: column;
        margin-left: 4px;
        width: 100%;
    }
}
</style>
